import React, { useState } from 'react';
import axios from 'axios';
import * as API from "../../Endpoints/Endpoints";
import { useNavigate } from "react-router-dom"; 

const AddCube = () => {
  const [formData, setFormData] = useState({
    religion: '',
    theme: '',
    type: '',
    passiondimension: '',
    question: '',
    relatedSDG: '',
    agegroup: '',
    knownreligiouslead: '',
    briefdescriptionoflead: ''
  });

  const navigate = useNavigate(); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(API.POST_CUBE_API,formData);
      if (response.status === 201 || response.status === 200) {
        alert('Data added successfully!');
        navigate("/cubemaster"); 
        setFormData({
          religion: '',
          theme: '',
          type: '',
          passiondimension: '',
          question: '',
          relatedSDG: '',
          agegroup: '',
          knownreligiouslead: '',
          briefdescriptionoflead: ''
        });
      } else {
        alert('Failed to add data.');
      }
    } catch (error) {
      console.error('Error adding data:', error);
      alert('An error occurred while adding data.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-lg p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
          Add Cube Game Data
        </h2>
        <form onSubmit={handleSubmit}>
          {Object.keys(formData).map((field) => (
            <div className="mb-4" key={field}>
              <label className="block text-sm font-medium text-gray-700 mb-1 capitalize">
                {field.replace(/([A-Z])/g, ' $1')}
              </label>
              <input
                type="text"
                name={field}
                value={formData[field]}
                onChange={handleChange}
                placeholder={`Enter ${field}`}
                className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
                required
              />
            </div>
          ))}

          <button
            type="submit"
            className="w-full bg-[#e64a32] text-white py-2 px-4 rounded-lg hover:bg-[#c64028] focus:outline-none"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddCube;
